<template>
  <div
    class="modal fade"
    id="editVatRatesModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ lang.EVR000 }} - {{ lang.EVR001 }}</b>
          </h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label
              for="selectEditVatRatesCountry"
              class="col-md-4 control-label"
              >{{ lang.EVR002 }}</label
            >
            <div class="col-md-8">
              <select2
                class="form-control"
                id="selectEditVatRatesCountry"
                v-model="selectedCountry"
              >
                <option></option>
                <option
                  v-for="(name, code) in globals.countryList"
                  :key="code"
                  :value="code"
                >
                  {{ name }}
                </option>
              </select2>
            </div>
          </div>
          <div class="form-group">
            <label for="inputEditVatRatesValue" class="col-md-4 control-label"
              >{{ lang.EVR003 }} (%)</label
            >
            <div class="col-md-8">
              <input
                class="form-control"
                id="inputEditVatRatesValue"
                type="number"
                step="any"
                @change="vatDataDirty = true"
                v-model.number="vatRatePercentage"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-raised" data-dismiss="modal">
            {{ lang.EVR004 }}
          </button>
          <button
            type="button"
            class="btn btn-raised btn-success"
            :class="{ 'btn-warning': vatDataDirty }"
            @click="saveVatRates()"
          >
            {{ lang.EVR005 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Select2";

export default {
  name: "EditVatRatesModal",
  components: {
    Select2,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      vatDataDirty: false,
      selectedCountry: "",
      currentEntry: {
        CountryCode: "",
        VatRate: undefined,
      },
      vatDataList: [],
      lang: {
        EVR000: "VAT",
        EVR001: "Tax Rates",
        EVR002: "Country",
        EVR003: "VAT Rate",
        EVR004: "Close",
        EVR005: "Save",
      },
    };
  },
  computed: {
    vatRatePercentage: {
      get() {
        if (!this.currentEntry.VatRate) return undefined;
        return (this.currentEntry.VatRate * 100).toFixed(2);
      },
      set(value) {
        if (!value || value < 0) value = 0;
        if (value > 100) value = 100;
        this.currentEntry.VatRate = Number.parseFloat((value / 100).toFixed(4));
      },
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
    },
    showModal(newVal) {
      newVal ? this.openModal() : this.closeModal();
    },
    selectedCountry(newCountryCode) {
      let entry = _.find(
        this.vatDataList,
        (v) => v.CountryCode === newCountryCode
      );
      if (!entry) {
        entry = {
          CountryCode: newCountryCode,
          VatRate: undefined,
        };
        this.vatDataList.push(entry);
      }
      this.currentEntry = entry;
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
    }

    $("#editVatRatesModal").on("hidden.bs.modal", (e) =>
      this.$emit("modalClosed")
    );
  },
  methods: {
    openModal() {
      this.vatDataDirty = false;
      let success = () => {
        this.$nextTick(() => {
          this.selectedCountry = "DE";
          $("#editVatRatesModal").modal("show");
        });
      };
      this.getVatRates(success);
    },
    closeModal() {
      $("#editVatRatesModal").modal("hide");
    },
    getVatRates(success) {
      this.selectedCountry = "";
      let query = `api/Administration/VatRates#test`;
      $.ajax({
        method: "GET",
        url: query,
        success: (data) => {
          this.vatDataList = data;
          if (success) success();
        },
        error: () => {
          console.error("Error on GET in getVatRates()");
          this.globals.showErrorSnackbar("Tax rates data access failed");
        },
      });
    },
    saveVatRates() {
      let sendData = _.cloneDeep(this.vatDataList);
      _.remove(sendData, (entry) => {
        return !entry.VatRate;
      });

      let query = `api/Administration/VatRates`;
      $.ajax({
        method: "PUT",
        url: query,
        data: JSON.stringify(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.globals.showSuccessSnackbar("Tax rates updated");
          this.vatDataDirty = false;
        },
        error: (error) => {
          console.error("Error on PUT in saveVatRates()");
          this.globals.showErrorSnackbar("Tax rates update failed");
        },
      });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// EditVatRatesModal.vue?718058b8